export default __webpack_public_path__ + "static/architecture-mobile-image-8ba43c77a7362ab8ee07ce19cbbeabec.jpg";